import { Box } from '@chakra-ui/layout'
import React from 'react'

const LegalScreen: React.FC = ({ children }) => {
  return <Box p={['4', '8', '12']}>{children}</Box>
}

export default LegalScreen
